export default __webpack_public_path__ + "static/media/evenShotMascot.3ee8724b.png";